<template>
  <v-menu
    open-on-hover
    offset-y
  >
    <template
      v-slot:activator="{ on, attrs }"
    >
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
        class="header__locale-menu"
      >
        {{ locale }}

        <v-icon>{{ chevronIcon }}</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        class="header__locale-menu"
        v-for="(locale, index) in otherLocales"
        :key="index"
        @click="changeLocale(locale)"
      >
        <v-list-item-title>{{ locale }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import { mdiChevronDown } from '@mdi/js'
  import { localstorageStore } from '../../../plugins/localforage'
  import i18n from '../../../plugins/i18n'

  export default {
    name: 'TheLocaleMenu',

    data() {
      return {
        chevronIcon: mdiChevronDown,
        locales: this.$store.state.locales,
      }
    },

    computed: {
      locale() {
        return this.$store.state.locale
      },

      otherLocales() {
        const otherLocales = this.locales
          .filter((locale) => !!locale && locale !== this.locale)
          .map((locale) => locale.toUpperCase())

        return [...new Set(otherLocales)]
      },
    },

    methods: {
      async changeLocale(locale) {
        const { dispatch, commit, state } = this.$store

        let transformedLocale = locale.toLowerCase()

        // if not online, window.reload() make an error
        // so the url is not translated but the app is not
        // reloaded
        if (!state.isOnline) {
          this.$i18n.locale = transformedLocale

          commit('setLocale', transformedLocale)
          await localstorageStore.setItem('locale', transformedLocale)

          return await this.$store.dispatch('fetchMenusFromApi')
        }

        const { name, params } = this.$route
        let path = `/${transformedLocale}`

        if (name === 'DetailPage') {
          const { locale: oldLocale, slug } = params

          const id = await dispatch('getIdFromSlug', { locale: oldLocale, slug })
          const newSlug = await dispatch('getSlugFromId', { locale: transformedLocale, id })

          path = `/${transformedLocale}/${this.$t('router.venue', transformedLocale)}/${newSlug}`
        }

        if (name === 'FavoritesPage') path = `/${transformedLocale}/${this.$t('router.my-venues', transformedLocale)}`
        if (name === 'AdvicePage') path = `/${transformedLocale}/${this.$t('router.advices', transformedLocale)}`

        window.history.pushState(null, '', path)
        return window.location.reload()
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  .v-menu__content
    box-shadow: none

  .header__locale-menu, .v-list-item__title
    color: $primary-color
    font-size: 15px
    font-weight: bold

  .theme--light.v-btn:hover::before, .theme--light.v-list-item:hover::before
    opacity: 0
</style>
